import { useEffect, useRef } from 'react';

export default function ScrollSpy() {
  const isUserClicking = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const headings = document.querySelectorAll('h2[id]');
    const tocLinks = document.querySelectorAll('.toc a');
    const topSentinel = document.getElementById('top-sentinel');

    const headingObserver = new IntersectionObserver(
      (entries) => {
        if (isUserClicking.current) return;
        entries.forEach((entry) => {
          const id = entry.target.getAttribute('id');
          if (entry.isIntersecting && id) {
            tocLinks.forEach((link) => {
              link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
            });
          }
        });
      },
      {
        rootMargin: '0px 0px -70% 0px',
        threshold: 1.0,
      }
    );

    headings.forEach((heading) => headingObserver.observe(heading));

    const topObserver = new IntersectionObserver(
      (entries) => {
        if (isUserClicking.current) return;
        if (entries[0].isIntersecting) {
          tocLinks.forEach((link) => link.classList.remove('active'));
        }
      },
      {
        rootMargin: '0px',
        threshold: 1.0,
      }
    );
    if (topSentinel) topObserver.observe(topSentinel);

    tocLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const targetId = link.getAttribute('href')?.slice(1);
        if (!targetId) return;

        isUserClicking.current = true;
        tocLinks.forEach((l) => l.classList.remove('active'));
        link.classList.add('active');

        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          isUserClicking.current = false;
        }, 800);
      });
    });

    return () => {
      headingObserver.disconnect();
      topObserver.disconnect();
      tocLinks.forEach((link) => {
        link.removeEventListener('click', () => {});
      });
    };
  }, []);

  return null;
}